import { DeleteOutlined } from '@ant-design/icons';
import { useContext } from 'react';

import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

type BedHeaderProps = {
  index: number;
  name: number;
  onRemove: (name: number) => void;
};

export const BedHeader = ({ index, name, onRemove }: BedHeaderProps) => {
  const { isEditMode } = useContext(ViewEditModeContext);

  return (
    <div className="bed-header">
      {`Bed #${(index + 1).toString().padStart(2, '0')}`}
      {index > 0 && isEditMode && (
        <DeleteOutlined
          className="delete-icon"
          onClick={() => onRemove(name)}
        />
      )}
    </div>
  );
};
